__turbopack_context__.v({
  "isCrypto": "QuoteHeader-module-scss-module__MKtvoW__isCrypto",
  "isSticky": "QuoteHeader-module-scss-module__MKtvoW__isSticky",
  "quoteHeaderWrapper": "QuoteHeader-module-scss-module__MKtvoW__quoteHeaderWrapper",
  "quoteTabsSticky": "QuoteHeader-module-scss-module__MKtvoW__quoteTabsSticky",
  "simple": "QuoteHeader-module-scss-module__MKtvoW__simple",
  "tabsSentinel": "QuoteHeader-module-scss-module__MKtvoW__tabsSentinel",
});
